// The map's control labels from the page (Search/partials/map_locale.html.twig)
export const mapLocale = (element: HTMLElement): Record<string, string> | undefined => {
  try {
    return JSON.parse(element.dataset.mapLocale ?? "");
  } catch {
    return undefined;
  }
};
